import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '@coreui/angular';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import { LocalStorageService } from '@services/root/local-storage.service';
import { StaffApiService } from '@services/rest/staff-api.service';
import { SignalRService } from '@services/rest/signalr.service';
import { AuthenticateApiService } from '@services/rest/authenticate-api.service';
import { TokenService } from '@services/rest/token.service';
import { SessionService } from '@services/rest/session.service';
import { PresenceService } from '@services/rest/presence.service';
import { ChangePasswordModalComponent } from '@shared/change-password-modal/change-password-modal.component';

// Extends CoreUI's HeaderComponent so <app-default-header> renders as a
// c-header host (sticky positioning, header classes) — mirrors the Carwins
// admin layout so both projects share the same header behaviour.
@Component({
    selector: 'app-default-header',
    templateUrl: './default-header.component.html',
    standalone: false
})
export class DefaultHeaderComponent extends HeaderComponent {

  @Input() sidebarId = 'sidebar';

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private bsModalService: BsModalService,
    private notification: NzNotificationService,
    private staffApiService: StaffApiService,
    private signalRService: SignalRService,
    private authenticateApiService: AuthenticateApiService,
    private tokenService: TokenService,
    private sessionService: SessionService,
    private presenceService: PresenceService,
  ) {
    super();
  }

  logout() {
    const refreshToken = this.tokenService.getRefreshToken();

    this.signalRService.stopConnection();
    this.sessionService.stop();
    this.presenceService.stop();
    this.localStorageService.clearAllLocalStorage();
    this.router.navigateByUrl('/login');

    // Revoke server-side after navigating away so a slow/failed request
    // never blocks the user from logging out locally.
    if (refreshToken) {
      this.authenticateApiService.Logout(refreshToken).subscribe({ error: () => { } });
    }
  }

  confirmationModel: BsModalRef;
  changePassword() {
    this.confirmationModel = this.bsModalService.show(
      ChangePasswordModalComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true
      }
    );

    this.confirmationModel.content.submitEvent.subscribe((changePasswordModel) => {
      this.staffApiService.changePassword(changePasswordModel).subscribe(response => {
        if (response.success) {
          this.showNotification('Password changed successfully', response.success);
        } else {
          this.showNotification(response.errorMessage, response.success);
        }
      });
    });
  }

  showNotification(message, status) {
    if (status) {
      this.notification.success(message, '');
    } else {
      this.notification.error(message, '');
    }
  }
}
